var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group",attrs:{"role":"group","id":_vm.id+'div'}},[_c('label',{staticClass:"d-block",attrs:{"for":_vm.para,"id":_vm.id+'Label'}},[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")]),_vm._v(" "),_c('div',[_vm._t("inputs")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }